<app-applicant-funnel-message-dialog
    [subject]="applicantJobFunnelMessageTemplate?.subject"
    [openDialog]="isChangeFunnelStageModalOpen"
    (confirmChangeFunnelStage)="onConfirmChangeFunnelStage()"
    (closeChangeFunnelStage)="onCloseChangeFunnelStage()"
>
</app-applicant-funnel-message-dialog>

<ui-dialog
    size="small"
    header="{{ 'delete' | translate }}"
    [open]="isDeleteApplicantDialogOpen"
    deleteDialog
    (closing)="closeDeleteApplicantDialog()"
    (primaryButtonPressed)="onDelete()"
    (secondaryButtonPressed)="closeDeleteApplicantDialog()"
>
    <p
        [innerHTML]="
            'applicant-tracker.applicants.areYouSureYouWantToDeleteApplicant'
                | translate
                    : {
                          name: applicant?.fullName,
                      }
                | sanitizeHtml
        "
    ></p>
</ui-dialog>

<!--
    TODO: I smell something funky here.

    Ideally I would like to be able to not render this dialog when
    it's not needed. However it seems to cause problems with the
    applicant. It ends up undefined which breaks things on this
    page but also child components subscribing to the model
    break as well.

    Not sure exactly what is happening but I thought I'd
    document this just in case I or someone else is
    able to solve this in the future.

    ~ with ❤️ from Fletch
-->
<!-- Copy Applicant Dialog-->
<ui-dialog
    [open]="isMoveAndCopyApplicantDialogOpen"
    header="{{ 'applicant-tracker.applicants.copyOrMoveApplicant' | translate }}"
    (closing)="closeMoveAndCopyApplicantDialog()"
>
    <!-- Loader -->
    <div *ngIf="isDialogLoading" class="ui active inverted dimmer">
        <div class="ui loader"></div>
    </div>

    <form #moveAndCopyForm="ngForm" autocomplete="off">
        <span>{{ 'applicant-tracker.applicants.moveOrCopyAnApplicantToAnotherJobPosting' | translate }}</span>

        <div class="app-grid margin-top-2">
            <div class="columns-12">
                <mat-radio-group
                    #copyAction="ngModel"
                    class="vertical"
                    name="copyAction"
                    [(ngModel)]="selectedCopyAction"
                    required
                >
                    <mat-radio-button value="copy" class="margin-bottom-2">{{
                        'applicant-tracker.applicants.copyApplicant' | translate
                    }}</mat-radio-button>

                    <mat-radio-button value="move" class="margin-bottom-2">{{
                        'applicant-tracker.applicants.moveApplicant' | translate
                    }}</mat-radio-button>
                </mat-radio-group>
                <mat-error *ngIf="copyAction.invalid">{{ copyAction.errors | formErrors }}</mat-error>
            </div>

            <mat-form-field class="columns-9">
                <mat-label appRemoveAriaOwns>{{ 'applicant-tracker.applicants.jobPosting' | translate }}</mat-label>
                <mat-select
                    name="jobPosting"
                    (selectionChange)="onJobPostingSelectionChange()"
                    [(ngModel)]="selectedJobPosting"
                    #jobPosting="ngModel"
                    required
                >
                    <mat-option *ngFor="let jobPosting of jobPostingsApplicantCanBeCopiedTo" [value]="jobPosting">{{
                        jobPosting.title
                    }}</mat-option>
                </mat-select>
                <mat-error *ngIf="jobPosting.invalid">{{ jobPosting.errors | formErrors }}</mat-error>
            </mat-form-field>

            <mat-form-field class="columns-9">
                <mat-label appRemoveAriaOwns>{{ 'applicant-tracker.applicants.funnelStage' | translate }}</mat-label>
                <mat-select name="funnelStage" [(ngModel)]="selectedFunnelStage" #funnelStage="ngModel" required>
                    <mat-option *ngFor="let funnelStage of funnelStagesFromSelectedJobPosting" [value]="funnelStage">{{
                        funnelStage.funnelStep | appTranslateOptions: jobFunnelDisplay
                    }}</mat-option>
                </mat-select>
                <mat-error *ngIf="funnelStage.invalid">{{ funnelStage.errors | formErrors }}</mat-error>
            </mat-form-field>
        </div>

        <ui-dialog-footer>
            <ui-button type="ghost" (click)="closeMoveAndCopyApplicantDialog()">{{
                'applicant-tracker.applicants.cancel' | translate
            }}</ui-button>
            <ui-button type="primary" (click)="onCopyApplicant()">{{
                'applicant-tracker.confirm' | translate
            }}</ui-button>
        </ui-dialog-footer>
    </form>
</ui-dialog>

<div *ngIf="applicant" class="ui basic segment" [class.loading]="isLoading">
    <app-header
        [title]="applicant.fullName"
        [backRoute]="backRoute"
        [back]="true"
        [menuService]="tabMenuService"
        class="applicantHeader"
        [badgeOptions]="applicantIsHired ? badgeHired : applicant.isArchived ? badgeWarning : badgeSuccess"
        [contextMenu]="!applicantIsHired"
        contextMenuType="material"
    >
        <div class="back-container-content flex margin-left-auto">
            <ui-button (click)="prevCandidate()" [disabled]="!previousApplicantId" type="ghost"
                ><mat-icon svgIcon="chevronLeft"></mat-icon
                >{{ 'applicant-tracker.applicants.previousApplicant' | translate }}</ui-button
            >
            <div class="vertical-divider"></div>
            <ui-button (click)="nextCandidate()" [disabled]="!nextApplicantId" type="ghost"
                >{{ 'applicant-tracker.applicants.nextApplicant' | translate }}
                <mat-icon svgIcon="chevronRight"></mat-icon
            ></ui-button>
        </div>
        <button *ngIf="hasRecruiterAccess" mat-menu-item (click)="showMoveAndCopyApplicantDialog()">
            {{ 'applicant-tracker.applicants.copyMoveApplicant' | translate }}
        </button>
        <button class="delete-applicant" mat-menu-item (click)="openDeleteApplicantDialog()">
            {{ 'delete' | translate }}
        </button>
        <div class="header-content margin-top-2 margin-left-1">
            <ui-star-rating
                name="starRating"
                *ngIf="applicant.rating !== null"
                [aria-label]="applicant.fullName"
                [(ngModel)]="applicant.rating"
                (ngModelChange)="onRate()"
            >
            </ui-star-rating>
        </div>
        <div class="buttons">
            <mat-form-field class="no-labels no-helpers margin-right-1">
                <mat-select
                    *ngIf="applicant.jobPosting"
                    class="funnel-select"
                    name="funnel"
                    [(ngModel)]="applicant.funnelId"
                    (ngModelChange)="onFunnelChange(applicant)"
                >
                    <mat-option *ngFor="let jobFunnel of getFunnels()" [value]="jobFunnel.id"
                        >{{ jobFunnel.funnelStep | translate }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <div class="flex">
                <ui-button *ngIf="!applicant.archivedAt" type="outline" (click)="onArchive()">{{
                    'applicant-tracker.applicants.archive' | translate
                }}</ui-button>
                <app-hire-drop-down
                    *ngIf="!applicantIsHired"
                    class="margin-left-1"
                    [applicant]="applicant"
                    (sendOfferClicked)="onSendOffer($event)"
                    (hireClicked)="onHire($event)"
                ></app-hire-drop-down>
                <ui-button class="margin-left-1" type="outline" *ngIf="applicant.archivedAt" (click)="onUnarchive()">{{
                    'applicant-tracker.applicants.unarchive' | translate
                }}</ui-button>
                <ui-button routerLink="./message" type="outline">{{
                    'applicant-tracker.applicants.emailApplicant' | translate
                }}</ui-button>
            </div>
        </div>
    </app-header>
    <router-outlet></router-outlet>
</div>
